"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var _ = require("lodash");
var _1 = require(".");
var tool = require("../tool");
var BaseElement = /** @class */ (function (_super) {
    __extends(BaseElement, _super);
    function BaseElement() {
        var _this = _super.call(this) || this;
        _this._reservedAttr = [];
        _this.hasFixedSize = false;
        _this._options._anchor = 32 /* Center */ | 4 /* Middle */;
        return _this;
    }
    BaseElement.prototype.render = function (isRoot) {
        var _this = this;
        if (isRoot === void 0) { isRoot = true; }
        if (isRoot) {
            this.setup();
            if (this._rendered && !this.hasAbsolutePosition) {
                var parent_1 = this.findFixedParent();
                parent_1.render(true);
                return;
            }
            this.prepare();
        }
        if (!this._preRender()) {
            return;
        }
        var _loop_1 = function (key) {
            if (key[0] === "_" || this_1._reservedAttr.indexOf(key) >= 0 || key === "transform") {
                return "continue";
            }
            this_1._callRender(function (node, d, i, g, h) {
                node.attr(key, h.op(key));
            });
        };
        var this_1 = this;
        for (var _i = 0, _a = this._dirtySVGOptions(); _i < _a.length; _i++) {
            var key = _a[_i];
            _loop_1(key);
        }
        this._render();
        if (this._options._rotation) {
            this._callRender(function (node, d, i, g, h) {
                var currTransform = node.attr("transform") || "";
                var r = h.op("_rotation");
                node.attr("transform", currTransform + " " + tool.rotateWithOrigin.apply(_this, r));
            });
        }
        if (this._options.transform) {
            this._callRender(function (node, d, i, g, h) {
                var currTransform = node.attr("transform") || "";
                var transform = h.op("transform");
                node.attr("transform", currTransform + " " + transform);
            });
        }
        this._postRender();
    };
    BaseElement.prototype._resetSize = function () {
        _super.prototype._resetSize.call(this);
        this.markDirty(["_width", "_height"]);
    };
    BaseElement.prototype._dirtySVGOptions = function () {
        return _.difference(_super.prototype._dirtySVGOptions.call(this), this._reservedAttr);
    };
    BaseElement.prototype.computedSize = function (elmOrIndex, forceRefresh) {
        var node = typeof elmOrIndex === "undefined" ?
            this.dom.node() :
            typeof elmOrIndex === "number" ? this.dom.nodes()[elmOrIndex] : elmOrIndex;
        return node.getBBox();
    };
    return BaseElement;
}(_1.PrototypeElement));
exports.BaseElement = BaseElement;
//# sourceMappingURL=base.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/bvd3/dist/element/base.js
// module id = 43
// module chunks = 0 1